module.exports = __webpack_public_path__ + "img/Selia_120X35.816b4f15.png";